export const config = {};

export function postData(url, data) {
  return new Promise((resolve, reject) => {
    fetch(config.baseUrl + url, {
      method: 'POST',
      headers: {
        RequestVerificationToken: config.cookie,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        response.text()
          .then(text => {
            try {
              const data = JSON.parse(text);
              if (response.status === 200) {
                resolve(data);
              } else {
                reject(data);
              }
            }
            catch {
              reject(text);
            }
          })
      });
  });
}

export function validation(className, flag) {
  return className + (flag ? ' invalid' : '');
}
